/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectPermissionDetail
 */
export interface ProjectPermissionDetail {
    /**
     * 
     * @type {number}
     * @memberof ProjectPermissionDetail
     */
    flag?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectPermissionDetail
     */
    name?: string;
}

/**
 * Check if a given object implements the ProjectPermissionDetail interface.
 */
export function instanceOfProjectPermissionDetail(value: object): value is ProjectPermissionDetail {
    return true;
}

export function ProjectPermissionDetailFromJSON(json: any): ProjectPermissionDetail {
    return ProjectPermissionDetailFromJSONTyped(json, false);
}

export function ProjectPermissionDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectPermissionDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'flag': json['flag'] == null ? undefined : json['flag'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ProjectPermissionDetailToJSON(json: any): ProjectPermissionDetail {
    return ProjectPermissionDetailToJSONTyped(json, false);
}

export function ProjectPermissionDetailToJSONTyped(value?: ProjectPermissionDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flag': value['flag'],
        'name': value['name'],
    };
}

